
import { ShieldCheck, Lock, Clock, MessageSquare } from 'lucide-react';
import { motion,  } from "framer-motion";
const trustFeatures = [
  {
    icon: ShieldCheck,
    title: 'Verified Experts',
    description: 'All experts are thoroughly verified and certified'
  },
  {
    icon: Lock,
    title: 'Secure & Confidential',
    description: 'Your privacy and data security is our priority'
  },
  {
    icon: Clock,
    title: '24/7 Availability',
    description: 'Connect with experts anytime, anywhere'
  },
  {
    icon: MessageSquare,
    title: 'Multiple Modes',
    description: 'Chat, call, or video consultation options'
  }
];

export function TrustSection() {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-gray-900 mb-3">Why Choose trueAdviso?</h2>
          <p className="text-gray-600 text-lg">
            Your trusted platform for expert consultations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustFeatures.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center"
            >
              <div className="mb-4 flex justify-center">
                <div className="w-16 h-16 bg-white rounded-2xl shadow-md flex items-center justify-center">
                  <feature.icon className="w-8 h-8 text-blue-600" />
                </div>
              </div>
              <h3 className="text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
